import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';

import { UserRole } from '@app/core/auth/user-role.enum';
import { AuthService } from '@app/core/services/auth-service/auth.service';
import { SidebarMenuComponent } from '@app/layout/sidebar-menu/sidebar-menu.component';
import { MENU_CONFIG } from '@app/layout/sidebar/menu-config';
import { SidebarMenuItems } from '@app/layout/sidebar/sidebar.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  imports: [
    NgOptimizedImage,
    CommonModule,
    MatSidenavModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatMenuModule,
    RouterModule,
    SidebarMenuComponent,
  ],
})
export class SidebarComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  showSidebar = input(false);
  showSidebarChange = output<boolean>();
  sidebarMenuItems: SidebarMenuItems[] = MENU_CONFIG;

  username = computed(() => this.authService.username());
  roles = computed(() => this.authService.userRoles());

  formattedRoles = computed(() =>
    this.roles().map((role: string) => {
      switch (role) {
        case UserRole.SUPER_ADMIN: return 'Super-Administrator';
        case UserRole.ADMIN: return 'Administrator';
        case UserRole.MANAGER: return 'Verwalter';
        case UserRole.USER: return 'Benutzer';
        case UserRole.DISPATCHER: return 'Disponent';
        case UserRole.TECHNICIAN: return 'Techniker';
        default: return role;
      }
    }).join(', ')
  );

  constructor() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.showSidebarChange.emit(false);
    });
  }

  logout() {
    this.authService.logout();
  }

  navigateToHome() {
    if (this.authService.isInRole(UserRole.SUPER_ADMIN)) {
      void this.router.navigate(['/dashboard/tenant-management']);
    } else {
      void this.router.navigate(['/dashboard/measurement-location-overview']);
    }
  }
}
